import {resolveSsoLinkUrlForOpenFromState} from '@/services/sso/ssoIccSessionInfoPolicy.wired';
import {makeSelectSsoLink} from '@/state/selectors/media';
import {invalidateSsoLink} from '@/state/slices/mediaSlice';
import {dispatch, getState} from '@/state/store';

export type MarkSsoLinkUsedParams = {
    ssoLinkKey?: string | null;
    openInBluefy?: boolean;
    isSsoCookiesForced?: boolean;
};

/**
 * Marks a cached SSO link as consumed. Single-use signed URLs are invalidated so
 * mounted fetch hooks regenerate a fresh token.
 */
export const markSsoLinkUsed = ({
    ssoLinkKey,
    openInBluefy = false,
    isSsoCookiesForced = false,
}: MarkSsoLinkUsedParams): void => {
    if (!ssoLinkKey) return;

    const entry = makeSelectSsoLink(ssoLinkKey)(getState!());
    const resolvedUrl = resolveSsoLinkUrlForOpenFromState(entry, openInBluefy, isSsoCookiesForced);

    if (!resolvedUrl || !entry.url) return;

    if (resolvedUrl === entry.url) {
        dispatch!(invalidateSsoLink({ssoTemplate: ssoLinkKey}));
    }
};
